import { push } from 'react-router-redux';

import { fetchPOST } from '../../resources/fetchHelper';
import {
  sendStats,
  APPEAL_CANCEL_ERROR_STAT,
  APPEAL_CANCEL_SUCCESS_STAT
} from '../../resources/metrics';
import { deleteDraft } from '../draft/actions';

import {
  APPEAL_CANCEL_REQUEST,
  APPEAL_CANCEL_SUCCESS,
  APPEAL_CANCEL_ERROR,
  APPEAL_CANCEL_RESET
} from '../constants';
import apiRoutes from '../../resources/apiRoutes';

export default function cancelAppeal(payload) {
  return dispatch => {
    const onError = () => {
      sendStats(APPEAL_CANCEL_ERROR_STAT());
      dispatch({ type: APPEAL_CANCEL_ERROR });
    };

    dispatch({ type: APPEAL_CANCEL_REQUEST });

    fetchPOST(apiRoutes.getAppealCancelUrl(), { service_number: payload })
      .then(response => {
        if (response.code === 'SUCCESS' || response.code === 'OK') {
          sendStats(APPEAL_CANCEL_SUCCESS_STAT());
          dispatch({ type: APPEAL_CANCEL_SUCCESS });
          dispatch(deleteDraft());
          dispatch(push(`/cancel/success-cancel/${payload}`));
        } else {
          onError();
        }
      })
      .catch(onError);
  };
}

export const cancelAppealReset = () => ({ type: APPEAL_CANCEL_RESET });
